var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSaveButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#38CA60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2949 12.6875H18.6631C19.1015 12.6875 19.458 12.331 19.458 11.8926V8.03369H12.5V11.8925C12.5 12.331 12.8564 12.6875 13.2949 12.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 16.5239H16.2031C16.4795 16.5239 16.7031 16.2998 16.7031 16.0239C16.7031 15.748 16.4795 15.5239 16.2031 15.5239H12.96C12.6836 15.5239 12.46 15.748 12.46 16.0239C12.46 16.2997 12.6836 16.5239 12.96 16.5239Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 18.5239H18.2032C18.4796 18.5239 18.7031 18.2998 18.7031 18.0239C18.7031 17.748 18.4795 17.5239 18.2032 17.5239H12.96C12.6836 17.5239 12.46 17.748 12.46 18.0239C12.46 18.2998 12.6836 18.5239 12.96 18.5239Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 19.5229H12.96C12.6836 19.5229 12.46 19.747 12.46 20.023C12.46 20.2988 12.6836 20.5229 12.96 20.5229H20.2031C20.4795 20.5229 20.7031 20.2988 20.7031 20.023C20.7031 19.747 20.4795 19.5229 20.2031 19.5229Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.03369H20.458V11.8925C20.458 12.8822 19.6533 13.6875 18.6631 13.6875H13.2949C12.3047 13.6875 11.5 12.8822 11.5 11.8925V8.03369H10.6455C9.73731 8.03369 9 8.77048 9 9.67963V21.3202C9 22.2294 9.73731 22.9663 10.6455 22.9663H22.3545C23.2637 22.9663 24.0001 22.2295 24.0001 21.3202V11.0541L21 8.03369ZM21.7492 20.2035C21.7492 20.7597 21.298 21.2104 20.7423 21.2104H12.1924C11.6367 21.2104 11.1856 20.7597 11.1856 20.2035V15.8427C11.1856 15.2865 11.6367 14.8354 12.1924 14.8354H20.7423C21.298 14.8354 21.7492 15.2865 21.7492 15.8427V20.2035ZM22.875 13.0624H21.4375V11.625H22.875V13.0624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveButton);
export default __webpack_public_path__ + "static/media/icon-save-button.22629f881aa9a589c71f4c602c886cb8.svg";
export { ForwardRef as ReactComponent };